module.exports = __webpack_public_path__ + "img/bg4.adc6f8c5.jpg";